import React from "react";
import { RfxReadOnlyPreview } from "../RfxReadOnlyPreview";

interface RfxReadOnlyPreviewPageProps {
	path?: string;
	/** Route param — this surface is addressed by RFx UUID only, never numeric id. */
	rfxUuid?: string;
}

/**
 * Route mount for the read-only preview (PRO-637 Task 011). Reached from the
 * Panel page (cross-company panel member) and from a guest deep link
 * (pre-accept invite). Registered at `rfx/:rfxUuid/preview` in both the
 * company-scoped (Account.js/Supplier.js) and Guest.js route trees.
 */
export const RfxReadOnlyPreviewPage = ({
	rfxUuid,
}: RfxReadOnlyPreviewPageProps) => {
	if (!rfxUuid) {
		return null;
	}

	return <RfxReadOnlyPreview rfxUuid={rfxUuid} />;
};
